"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initTotalCountSaga = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
var loadCustomElementsSaga_1 = require("../loadCustomElements/loadCustomElementsSaga");
var slice_1 = require("../store/slice");
var sagas_1 = require("../common/sagas");
var selectors_1 = require("../common/selectors");
/**
 * @internal
 */
function initTotalCountSaga(correlation) {
    var initTotalCountCorrelation, context, elementsForm, _a, success, error;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                initTotalCountCorrelation = "initTotalCount_" + correlation;
                return [4 /*yield*/, effects_1.call(sagas_1.getAttributeFilterContext)];
            case 1:
                context = _b.sent();
                return [4 /*yield*/, effects_1.select(selectors_1.selectElementsForm)];
            case 2:
                elementsForm = _b.sent();
                return [4 /*yield*/, effects_1.fork(loadCustomElementsSaga_1.loadCustomElementsSaga, slice_1.actions.loadCustomElementsRequest({
                        options: {
                            limit: 1,
                            includeTotalCountWithoutFilters: true,
                            excludePrimaryLabel: !context.backend.capabilities.supportsElementUris && elementsForm === "values",
                        },
                        correlation: initTotalCountCorrelation,
                    }))];
            case 3:
                _b.sent();
                return [4 /*yield*/, effects_1.race({
                        success: effects_1.take(function (a) {
                            return slice_1.actions.loadCustomElementsSuccess.match(a) &&
                                a.payload.correlation === initTotalCountCorrelation;
                        }),
                        error: effects_1.take(function (a) {
                            return slice_1.actions.loadCustomElementsError.match(a) &&
                                a.payload.correlation === initTotalCountCorrelation;
                        }),
                        cancel: effects_1.take(function (a) {
                            return slice_1.actions.loadCustomElementsCancel.match(a) &&
                                a.payload.correlation === initTotalCountCorrelation;
                        }),
                    })];
            case 4:
                _a = _b.sent(), success = _a.success, error = _a.error;
                if (!error) return [3 /*break*/, 5];
                throw error.payload.error;
            case 5:
                if (!success) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.put(slice_1.actions.setElementsTotalCount({
                        totalCount: success.payload.totalCount,
                    }))];
            case 6:
                _b.sent();
                _b.label = 7;
            case 7: return [2 /*return*/];
        }
    });
}
exports.initTotalCountSaga = initTotalCountSaga;
//# sourceMappingURL=initTotalCount.js.map